import request  from './axiosFun';
import apiLogin  from './axiosLogin';
// 登录
// 根据用户id，项目id 查询用户开通项目
var url = ''
if (process.env.NODE_ENV === 'development') {
  url = '/est'
} else {
  url = ''
}

export function accountLogin(query) {
  return request({
    url: url + '/pasture/userInfo/accountLogin',
    method: 'post',
    data:query
  })
}
export function getUserOpen(query) {

  return request({
    url: url + '/pasture/userInfo/getUserOpenApplication',
    method: 'post',
    data:query
  })
}
// 获取秘钥
export function getSecret(query) {
  return request({
    url: url + '/base-server/loginInfo/getSecret/web',
    method: 'post',
    data: query
  })
}
// 验证码登录
export function loginCode(query, token) {
  return apiLogin({
    url: url + '/auth/oauth2/token?grant_type=mobile&mobile=APP-SMS@' + query.mobile + '&code=' + query.code,
    method: 'post',
    headers: {
      Authorization: 'Basic ' + token,
      contentType: 'application/x-www-form-urlencoded',
    },
    data: JSON.stringify(
      {
        scope: query.scope
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js